import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=4f09841e&"
import script from "./FileRow.vue?vue&type=script&lang=js&"
export * from "./FileRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f09841e')) {
      api.createRecord('4f09841e', component.options)
    } else {
      api.reload('4f09841e', component.options)
    }
    module.hot.accept("./FileRow.vue?vue&type=template&id=4f09841e&", function () {
      api.rerender('4f09841e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/components/FileRow.vue"
export default component.exports